// src/components/UserProfile.jsx
import React, { useState } from 'react';
import { Container, Card, Button, Alert, Row, Col, Badge, Nav, Tab } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';
import AppNavbar from './Navbar';
import MobileNavbar from "./MobileNavbar.jsx";
import ProfileTab from './ProfileTab';
import GroupTab from './GroupTab';
import { useDevice } from '../contexts/DeviceContext';
import { useNavigation } from '../services/useNavigation';

const UserProfile = () => {
    const { user, isGroupAdmin } = useAuth();
    const { isMobile, isTablet, isDesktop, windowWidth } = useDevice();
    const { handleNavItemClick } = useNavigation();

    const [activeComponent, setActiveComponent] = useState('profile');
    const [activeTab, setActiveTab] = useState('profile');

    // Global message state for both tabs
    const [globalSuccess, setGlobalSuccess] = useState('');
    const [globalError, setGlobalError] = useState('');

    // Handle success messages from child components
    const handleSuccess = (message) => {
        setGlobalSuccess(message);
        setGlobalError('');

        // Clear success message after 5 seconds
        if (message) {
            setTimeout(() => {
                setGlobalSuccess('');
            }, 5000);
        }
    };

    // Handle error messages from child components
    const handleError = (message) => {
        setGlobalError(message);
        setGlobalSuccess('');
    };

    // Handle edit profile button click
    const handleEditProfile = () => {
        // Trigger edit mode in ProfileTab
        const editButton = document.getElementById('profile-edit-btn');
        if (editButton) {
            editButton.click();
        }
    };

    // Format date helper function
    const formatDate = (timestamp) => {
        if (!timestamp) return 'N/A';

        try {
            // Handle Firestore timestamp
            if (timestamp.seconds) {
                return new Date(timestamp.seconds * 1000).toLocaleDateString();
            }
            // Handle regular date
            return new Date(timestamp).toLocaleDateString();
        } catch (error) {
            return 'N/A';
        }
    };

    if (!user) {
        return (
            <div className="dashboard-wrapper user-profile">
                <div className="d-none d-md-block">
                    <AppNavbar />
                </div>
                <MobileNavbar
                    onNavItemClick={handleNavItemClick}
                    activeItem={activeComponent}
                />
                <Container className="py-4">
                    <Row>
                        <Col lg={8} className="mx-auto">
                            <Alert variant="warning">
                                Please log in to view your profile.
                            </Alert>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }

    return (
        <div className="dashboard-wrapper user-profile">
            {/* Desktop Navbar */}
            <div className="d-none d-md-block">
                <AppNavbar />
            </div>

            {/* Mobile Navbar */}
            <MobileNavbar
                onNavItemClick={handleNavItemClick}
                activeItem={activeComponent}
            />

            <Container className="py-4">
                <Row>
                    <Col lg={8} className="mx-auto">
                        <Card>
                            <Card.Header className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <h4 className="mb-0 me-3">User Profile</h4>
                                    {user.isGroupAdmin && (
                                        <Badge bg="primary">Admin</Badge>
                                    )}
                                </div>
                                {activeTab === 'profile' && (
                                    <Button
                                        variant="primary"
                                        onClick={handleEditProfile}
                                        size="sm"
                                    >
                                        Edit Profile
                                    </Button>
                                )}
                            </Card.Header>

                            <Card.Body>
                                {/* Global Messages */}
                                {globalError && (
                                    <Alert
                                        variant="danger"
                                        dismissible
                                        onClose={() => setGlobalError('')}
                                        className="mb-3"
                                    >
                                        {globalError}
                                    </Alert>
                                )}
                                {globalSuccess && (
                                    <Alert
                                        variant="success"
                                        dismissible
                                        onClose={() => setGlobalSuccess('')}
                                        className="mb-3"
                                    >
                                        {globalSuccess}
                                    </Alert>
                                )}

                                <Tab.Container
                                    activeKey={activeTab}
                                    onSelect={(k) => {
                                        setActiveTab(k);
                                        // Clear messages when switching tabs
                                        setGlobalError('');
                                        setGlobalSuccess('');
                                    }}
                                >
                                    <Nav variant="tabs" className="mb-4">
                                        <Nav.Item>
                                            <Nav.Link eventKey="profile">
                                                Profile Information
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="group">
                                                Group & Members

                                            </Nav.Link>
                                        </Nav.Item>
                                    </Nav>

                                    <Tab.Content>
                                        <Tab.Pane eventKey="profile">
                                            <ProfileTab
                                                onSuccess={handleSuccess}
                                                onError={handleError}
                                            />
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="group">
                                            <GroupTab
                                                onSuccess={handleSuccess}
                                                onError={handleError}
                                            />
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Tab.Container>
                            </Card.Body>
                        </Card>

                        {/* Quick Stats Card */}
               {/*         <Card className="mt-4">*/}
               {/*             <Card.Header>*/}
               {/*                 <h6 className="mb-0 text-primary">Quick Information</h6>*/}
               {/*             </Card.Header>*/}
               {/*             <Card.Body>*/}
               {/*                 <Row>*/}
               {/*                     <Col md={3} className="text-center">*/}
               {/*                         <div className="border-end">*/}
               {/*                             <h6 className="text-muted mb-1">Status</h6>*/}
               {/*                             <Badge bg={user.profileComplete ? "success" : "warning"}>*/}
               {/*                                 {user.profileComplete ? "Complete" : "Incomplete"}*/}
               {/*                             </Badge>*/}
               {/*                         </div>*/}
               {/*                     </Col>*/}
               {/*                     <Col md={3} className="text-center">*/}
               {/*                         <div className="border-end">*/}
               {/*                             <h6 className="text-muted mb-1">Role</h6>*/}
               {/*                             <div>{user.isGroupAdmin ? "Admin" : "Member"}</div>*/}
               {/*                         </div>*/}
               {/*                     </Col>*/}
               {/*                     <Col md={3} className="text-center">*/}
               {/*                         <div className="border-end">*/}
               {/*                             <h6 className="text-muted mb-1">Group</h6>*/}
               {/*                             <div>{user.groups[0]}</div>*/}
               {/*                         </div>*/}
               {/*∂                     </Col>*/}
               {/*                     <Col md={3} className="text-center">*/}
               {/*                         <div>*/}
               {/*                             <h6 className="text-muted mb-1">Email Verified</h6>*/}
               {/*                             <Badge bg={user.emailVerified ? "success" : "danger"}>*/}
               {/*                                 {user.emailVerified ? "Yes" : "No"}*/}
               {/*                             </Badge>*/}
               {/*                         </div>*/}
               {/*                     </Col>*/}
               {/*                 </Row>*/}
               {/*             </Card.Body>*/}
               {/*         </Card>*/}
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default UserProfile;